import { Grid, Group } from "@mantine/core";
import { Ref } from "react";
import DocumentTable from "../../DocumentTable";
import Text from "@/components/atoms/Text";
import { ORDER_DRAWER_DOCUMENTS_COLUMN } from "../../DocumentTable/const/order-drawer";
import { DocumentSchema, DocumentSchemaFormInput } from "../validation/documents";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CreateOrderFromContractValues } from "../index";

interface Props {
  onValidationSuccess: (data: any) => void;
  onChangeWizardData: (changed: any) => void;
  wizardData: CreateOrderFromContractValues;
  ref?: Ref<HTMLFormElement>;
}

function DocumentsStep({ onValidationSuccess, onChangeWizardData, ref }: Props) {
  const { handleSubmit, watch, setValue } = useForm<DocumentSchemaFormInput>({
    resolver: zodResolver(DocumentSchema),
    defaultValues: {
      selectedDocuments: [],
    },
  });
  const { t } = useTranslation();

  const selectedRows = watch("selectedDocuments");

  const handleSelectedRowsChange = (rows: string[]) => {
    setValue("selectedDocuments", rows);
  };

  const handleSubmitForm = handleSubmit((data) => {
    onValidationSuccess(data);
    onChangeWizardData(data);
  });

  return (
    <form ref={ref} onSubmit={handleSubmitForm}>
      <Grid>
        <Grid.Col>
          <Group gap={4}>
            <Text>{t("orders:attachDocuments")}</Text>
            <Text size="sm" c="dimmed">
              {t("orders:numOfAttachedDocuments", {
                amountSelected: selectedRows.length,
              })}
            </Text>
          </Group>
          <DocumentTable
            visibleColumns={ORDER_DRAWER_DOCUMENTS_COLUMN}
            selectable={true}
            selectedRows={selectedRows}
            setSelectedRows={handleSelectedRowsChange}
          />
        </Grid.Col>
      </Grid>
    </form>
  );
}

export default DocumentsStep;
